// *Manager self-service homepage main component*

// NOTE:
// all components in ./components are a child of this component, main logic and data is stored here
// The avatar menu for mobile is directly imported and used here, while desktop avatar menu is imported
// in ./Components/HomeHead.js
// All styles are in ../../../../../Assets/Styles/Home.scss

// STATE NAMES:
// The state initially contains static color codes for profile image placeholder in child components,
// SizeOptions state for items per page select dropdown, and PageInfo state is for storing Pagination
// data similar to EmployeeList component. TabIds state is the id of the 3 main tabs (top jobs, top projects,
// top activities) and is used in functions inside a map() method to find the active tab and determine the type
// of JPA that the user is taking actions on ("position", "activity", "project") in API requests.

// NOTE:
// Page data is refreshed by clicking the active tab or active page number (based on requirements);
// function names: clickActivePage()
// Initialization functions to fetch data on mount are called inside useEffect hook.
// Every API call logs data to the console for tracking data exchange, request data and request status.

import React, { useState, useEffect } from "react";
import ContentHeader from "../../ShareElements/ContentHeader/ContentHeader";
import SampleUser from "../../../../../Assets/Images/Ellipse 194.png";
import PlusCircle from "../../../../../Assets/Images/plus-circle.svg";
import "../../../../../Assets/Styles/Home.scss";
import { Config } from "../../../../../Config";
import axios from "axios";
import HomeHead from "./Components/HomeHead";
import WorkIcon from "../../../../../Assets/Images/work_black_2.svg";
import UserCheck from "../../../../../Assets/Images/user-check.svg";
import UserAvatar from "../../../../../Assets/Images/sampleuser.png";
import UsersPlural from "../../../../../Assets/Images/users.svg";
import FolderPlus from "../../../../../Assets/Images/folder-plus.svg";
import MessageCircle from "../../../../../Assets/Images/message-circle-dark.svg";
import { Link } from "react-router-dom/cjs/react-router-dom";
import MobileMSSStarterItem from "./Components/MobileMSSStarterItem";
import MobileAvatarMenu from "./Components/MobileAvatarMenu";
import ProfileImageUploader from "./Components/ProfileImageUploader";
import HeaderImageUploader from "./Components/HeaderImageUploader";
import HR_MSS_AdminGuide from "../../UserGuide/Components/HR_MSS_AdminGuide";

const MSSHome = (props) => {
  const [UserInfo, setUserInfo] = useState();
  const [EmployeePos, setEmployeePos] = useState();
  const [HeaderEditorIsOpen, setHeaderEditorIsOpen] = useState(false);
  const [AvatarEditIsOpen, setAvatrEditIsOpen] = useState(false);
  const [UploadedAvatar, setUploadedAvatar] = useState();
  const [MobileAvatarMenuIsOpen, setMobileAvatarMenuIsOpen] = useState(false);
  const [AvatarURL, setAvatarURL] = useState("");
  const [HeaderURL, setHeaderURL] = useState("");
  const [UploadedHeaderImage, setHeaderImage] = useState();
  const [MoreLikeThisIsActive, setMoreLikeThisIsActive] = useState(false);
  const [MSSSummary, setMSSSummary] = useState({
    totalApplications: 0,
    totalCandidateRecommendations: 0,
    totalJpaRecommendations: 0,
  });

  useEffect(() => {
    getUserInfo();
    getUserImage();
    getUserHeader();
    fetchEmpPositionInfo();
    removeLocalStorageItems();
    fetchMSSHomepageSummary();
  }, []);

  const checkNotificationRedirect = (UserInfoRes) => {
    if (
      window.localStorage.getItem("RedirectToken") !== "undefined" &&
      window.localStorage.getItem("RedirectToken") !== null
    ) {
      // This item is set to "undefined" on the login page
      // where there is no url param detected for redirection.
      let RedirectInfo = JSON.parse(
        atob(window.localStorage.getItem("RedirectToken"))
      );

      if (RedirectInfo.loggedInEmployeeId === UserInfoRes.id) {
        document.getElementById("link-to-ess-home-navlink").click();
      }
      // window.localStorage.removeItem("RedirectToken");
    }
  };

  const removeLocalStorageItems = () => {
    window.localStorage.removeItem("chat_jpaId");
    window.localStorage.removeItem("chat_recipientId");
    window.localStorage.removeItem("EmpFilesUploaded");
    window.localStorage.removeItem("PosFilesUploaded");
    window.localStorage.removeItem("chat_workCiy");
    window.localStorage.removeItem("chat_title");
    window.localStorage.removeItem("chat_jpaType");
    window.localStorage.removeItem("chat_source");
    window.localStorage.removeItem("TempChatroom");
  };

  const fetchEmpPositionInfo = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/current-position",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setEmployeePos(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  const getUserInfo = () => {
    let Req = {
      method: "GET",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/profile",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setUserInfo(Res.data);
        checkNotificationRedirect(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const fetchMSSHomepageSummary = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.NotificationService +
        "/api/notification/summary",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setMSSSummary(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const getUserImage = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/profile/profile-picture",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setAvatarURL(Res.data.imageUrl);
        props.GetUserInfo();
      })
      .catch((Err) => {
        console.log(Err);
        setAvatarURL("");
      });
  };
  const getUserHeader = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/profile/profile-background",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        setHeaderURL("");
        console.log(Res);
        if (Res.data.imageUrl.length > 0) {
          setHeaderURL(Res.data.imageUrl);
        }
      })
      .catch((Err) => {
        console.log(Err);
        setHeaderURL("");
      });
  };

  const toggleEditHeader = () => {
    if (window.innerWidth > 450) {
      if (HeaderURL.length > 1) {
        setHeaderEditorIsOpen(true);
      } else {
        document.getElementById("header-image").click();
      }
    }
  };

  const toggleEditAvatar = () => {
    if (window.innerWidth <= 450) {
      toggleMobileAvatarMenu();
    }
  };
  const toggleMobileAvatarMenu = () => {
    setMobileAvatarMenuIsOpen(true);
  };

  const toggleFifthGuide = () => {
    props.SetNavBookmarksGuideIsOpen(true);
    props.SetFooterJPAsGuideIsOpen(false);
    props.SetUserProfileGuideIsOpen(false);
  };
  const toggleSixthGuide = () => {
    props.ToggleSixthGuide();
  };
  const ToggleSeventhGuide = () => {
    props.SetSkillRecomGuideIsOpen(true);
    props.SetUserProfileGuideIsOpen(false);
  };
  const toggleEighthGuide = () => {
    props.SetHeaderGuideIsOpen(true);
    props.SetSkillRecomGuideIsOpen(false);
  };

  const handleHeaderImageUploaded = (e) => {
    if (e.target.files[0] === undefined) {
      setHeaderImage(HeaderURL);
      document
        .getElementById("apply-profile-btn")
        .classList.add("apply-disabled");
    } else {
      setHeaderImage(e.target.files[0]);
      setTimeout(() => {
        document
          .getElementById("apply-profile-btn")
          .classList.remove("apply-disabled");
      }, 300);
    }
    setHeaderEditorIsOpen(true);
  };

  const avatarUploaded = (e) => {
    if (e.target.files[0] === undefined) {
      setUploadedAvatar(AvatarURL);
      document
        .getElementById("apply-profile-btn")
        .classList.add("apply-disabled");
    } else {
      setUploadedAvatar(e.target.files[0]);
      setTimeout(() => {
        document
          .getElementById("apply-profile-btn")
          .classList.remove("apply-disabled");
      }, 400);
    }
    setAvatrEditIsOpen(true);
  };

  const closeMobileMenu = () => {
    setMobileAvatarMenuIsOpen(false);
  };

  const handleMobileMenuAvatarEdit = () => {
    setMobileAvatarMenuIsOpen(false);
    if (UserAvatar.length < 1) {
      document.getElementById("profile-image").click();
    } else {
      setAvatrEditIsOpen(true);
    }
  };

  const closeProfileImageUploader = () => {
    setAvatrEditIsOpen(false);
    setUploadedAvatar("");
  };

  const removeAvatarImage = () => {
    document.getElementById("profile-image").value = "";
    setUploadedAvatar("");
  };

  const changeAvatarImage = () => {
    document.getElementById("profile-image").click();
  };

  const closeHeaderUploader = () => {
    setHeaderEditorIsOpen(false);
    setHeaderImage("");
  };

  const removeHeaderImage = () => {
    setHeaderImage("");
  };

  const changeHeaderImage = () => {
    document.getElementById("header-image").click();
  };

  const toggleGuideStepJump = (Step) => {
    document.getElementById("link-to-ess-home-navlink").click();
    console.log("click");
    props.JumpToStep(Step);
  };

  return (
    <React.Fragment>
      <input
        type="file"
        accept=".jpg , .png, .jpeg"
        className="hidden"
        id="header-image"
        onChange={(e) => handleHeaderImageUploaded(e)}
      />
      <input
        type="file"
        id="profile-image"
        accept=".jpg , .png, .jpeg"
        className="hidden"
        onChange={(e) => avatarUploaded(e)}
      />
      {MobileAvatarMenuIsOpen ? (
        <MobileAvatarMenu
          CloseMenu={() => closeMobileMenu()}
          ToggleUpload={() => handleMobileMenuAvatarEdit()}
          LangData={props.LangData}
        />
      ) : null}
      {AvatarEditIsOpen ? (
        <ProfileImageUploader
          Close={() => closeProfileImageUploader()}
          RemoveImage={() => removeAvatarImage()}
          ChangeImage={() => changeAvatarImage()}
          FetchImage={() => getUserImage()}
          Image={UploadedAvatar}
          LangData={props.LangData}
        />
      ) : null}
      {HeaderEditorIsOpen ? (
        <div className="is-desktop">
          <HeaderImageUploader
            Close={() => closeHeaderUploader()}
            RemoveImage={() => removeHeaderImage()}
            ChangeImage={() => changeHeaderImage()}
            Image={UploadedHeaderImage}
            LangData={props.LangData}
            FetchImage={() => getUserHeader()}
          />
        </div>
      ) : null}
      <div className="main-content homepage">
        <ContentHeader PageName={translateText("home")} />
        <div className="content-header">
          <div className="address">
            <p>{translateText("home")}</p>
          </div>
        </div>
        <HomeHead
          SampleUser={SampleUser}
          EmployeePos={EmployeePos}
          PlusCircle={PlusCircle}
          UserAvatar={AvatarURL}
          HeaderImage={HeaderURL}
          UserInfo={props.UserInfo}
          LangData={props.LangData}
          ToggleEdit={() => toggleEditHeader()}
          ToggleEditAvatar={() => toggleEditAvatar()}
          Colors={{
            bg: props.UserInfo.backgroundColorCode,
            text: props.UserInfo.textColorCode,
          }}
          FetchImage={() => getUserHeader()}
          ToggleAvatarEditor={() => setAvatrEditIsOpen(true)}
          FetchNewJPAs={() => null}
          UserProfileGuideIsOpen={props.UserProfileGuideIsOpen}
          ToggleFifthGuide={() => toggleFifthGuide()}
          ToggleSixthGuide={() => toggleSixthGuide()}
          ToggleSeventhGuide={() => ToggleSeventhGuide()}
          ToggleEighthGuide={() => toggleEighthGuide()}
          SkillRecomGuideIsOpen={props.SkillRecomGuideIsOpen}
          JumpToStep={(Step) => props.JumpToStep(Step)}
          CloseGuide={() => props.CloseGuide()}
        />
        <div
          className="mss-start-grid is-mobile"
          style={
            props.AdminHomeGuideIsOpen
              ? { zIndex: "9999", position: "relative", background: "#f0f2f5" }
              : {}
          }
        >
          <section className="grid-head">
            <span className="grid-head-item">
              <img alt="" src={WorkIcon} />
              <p>
                {MSSSummary.totalJpaRecommendations + " "}{" "}
                {translateText("new_jpa_recommendations")}
              </p>
            </span>
            <span className="grid-head-item">
              <img alt="" src={UserCheck} />
              <p>
                {MSSSummary.totalCandidateRecommendations + " "}
                {translateText("new_candidate_recommendations")}
              </p>
            </span>
            <span className="grid-head-item">
              <img alt="" src={UsersPlural} />
              <p>
                {MSSSummary.totalApplications + " "}{" "}
                {translateText("new_applications")}
              </p>
            </span>
          </section>
          <MobileMSSStarterItem
            LangData={props.LangData}
            Icon={WorkIcon}
            ClickAction={null}
            Title={translateText("recommendations_uppercase")}
            LinkTo="/ess"
          />
          <MobileMSSStarterItem
            LangData={props.LangData}
            Icon={MessageCircle}
            ClickAction={null}
            LinkTo={"/communication"}
            Title={translateText("communication")}
          />
          <MobileMSSStarterItem
            LangData={props.LangData}
            Icon={UsersPlural}
            ClickAction={null}
            LinkTo={null}
            Title={translateText("applications")}
            IsCollapsible
            Links={[
              { name: translateText("vacancies"), route: "/vacancies" },
              { name: translateText("projects"), route: "/projects" },
              { name: translateText("activities"), route: "/activities" },
            ]}
          />
          <MobileMSSStarterItem
            LangData={props.LangData}
            Icon={FolderPlus}
            ClickAction={null}
            LinkTo={null}
            Title={translateText("create_and_publish")}
            IsCollapsible
            Links={[
              {
                name: translateText("create-vacancies"),
                route: "/createVacancies",
              },
              {
                name: translateText("create_projects"),
                route: "/createProjects",
              },
              {
                name: translateText("create_activities"),
                route: "/createActivities",
              },
            ]}
          />
        </div>
        {props.AdminHomeGuideIsOpen ? (
          <>
            <div className="overlay"></div>
            <HR_MSS_AdminGuide
              ToggleNextDialog={() => props.JumpToStep(1)}
              TogglePreviousDialog
              CloseGuide={() => props.CloseGuide()}
              togglePreviousGuide={null}
              JumpToStep={(Step) => toggleGuideStepJump(Step)}
              toggleNextGuide={() => props.JumpToStep(1)}
              LangData={props.LangData}
            />
          </>
        ) : null}
        <div className="mss-start-grid is-desktop">
          <section className="grid-head">
            <span className="grid-head-item">
              <img alt="" src={WorkIcon} />
              <p>
                {MSSSummary.totalJpaRecommendations + " "}
                {translateText("new_jpa_recommendations")}
              </p>
            </span>
            <span className="grid-head-item">
              <img alt="" src={UserCheck} />
              <p>
                {MSSSummary.totalCandidateRecommendations + " "}{" "}
                {translateText("new_candidate_recommendations")}
              </p>
            </span>
            <span className="grid-head-item">
              <img alt="" src={UsersPlural} />
              <p>
                {MSSSummary.totalApplications + " "}
                {translateText("new_applications")}
              </p>
            </span>
          </section>
          <div
            className={
              props.AdminHomeGuideIsOpen
                ? "mss-grid-actions is-overlayed"
                : "mss-grid-actions"
            }
          >
            <section className="grid-action-item" onClick={() => null}>
              <Link to="/ess">
                <div className="img work-icon"></div>
                <h2>{translateText("recommendations_uppercase")}</h2>
                <p>
                  {translateText("jobs")}, {translateText("projects")},{" "}
                  {translateText("activities")} (JPA)
                </p>
              </Link>
            </section>
            <section className="grid-action-item">
              <Link to={"/createVacancies"}>
                <div className="img folder-plus"></div>
                <h2>{translateText("create-vacancies")}</h2>
                <p>{translateText("candidate_recommendations")}</p>
              </Link>
            </section>
            <section className="grid-action-item">
              <Link to={"/createProjects"}>
                <div className="img folder-plus"></div>
                <h2>{translateText("create_projects")}</h2>
                <p>{translateText("candidate_recommendations")}</p>
              </Link>
            </section>
            <section className="grid-action-item">
              <Link to={"/createActivities"}>
                <div className="img folder-plus"></div>
                <h2>{translateText("create_activities")}</h2>
                <p>{translateText("candidate_recommendations")}</p>
              </Link>
            </section>
            <section className="grid-action-item">
              <Link to={"/communication"}>
                <div className="img message-circle"></div>
                <h2>{translateText("communication")}</h2>
                <p>{translateText("follow_ups")}</p>
              </Link>
            </section>
            <section className="grid-action-item">
              <Link to={"/vacancies"}>
                <div className="img users-plural"></div>
                <h2>{translateText("vacancies")}</h2>
                <p>{translateText("manage_applications")}</p>
              </Link>
            </section>
            <section className="grid-action-item">
              <Link to={"/projects"}>
                <div className="img users-plural"></div>
                <h2>{translateText("projects")}</h2>
                <p>{translateText("manage_applications")}</p>
              </Link>
            </section>
            <section className="grid-action-item">
              <Link to={"/activities"}>
                <div className="img users-plural"></div>
                <h2>{translateText("activities")}</h2>
                <p>{translateText("manage_applications")}</p>
              </Link>
            </section>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default MSSHome;
